

const DownArrowIcon = () => {
    return (
        <svg
            className="load_more_icon_interview_table"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 5v14M19 12l-7 7-7-7" />
        </svg>
    )
}

export default DownArrowIcon